import {
  Module,
  VuexModule,
  getModule,
  MutationAction
} from "vuex-module-decorators";
import store from "@/store/Store";
import StartedAttemptModel from "@/model/StartedAttemptModel";
import Axios, { AxiosResponse } from "axios";
import FinishedAttemptModel from "@/model/FinishedAttemptModel";
import AttemptModel from "@/model/AttemptModel";

@Module({
  dynamic: true,
  namespaced: true,
  name: "attempt",
  store
})
class AttemptModule extends VuexModule {
  attempt: AttemptModel | null = null;
  attemptUuid: string | null = null;

  @MutationAction
  async getAttemptUuid() {
    const url = new URL(window.location.href);
    const attemptUuid = url.searchParams.get("mojeznalosti");
    return {
      attemptUuid: attemptUuid as string
    };
  }

  @MutationAction
  async handlePublicUuid() {
    const url = new URL(window.location.href);
    const quizUuid = url.searchParams.get("mz-public");
    if (quizUuid !== null) {
      const response: AxiosResponse = await Axios.get(
        process.env.VUE_APP_API_URL + "/api/attempt/create-public/" + quizUuid
      );
      url.searchParams.delete("mz-public");
      url.searchParams.set("mojeznalosti", response.data.uid);
      console.log(url);
      window.history.pushState("", "", url.toString());
    }
    return {};
  }

  @MutationAction
  async fetchAttempt(uuid: string) {
    const response: AxiosResponse = await Axios.get(
      process.env.VUE_APP_API_URL + "/api/attempt/get/" + uuid
    ).catch(e => {
      window.location.replace("/404");
      throw new Error("Attempt with UID not found");
    });

    if (response.status !== 200) {
      window.location.replace("/404");
    }

    const data = response.data;
    if ("endsAt" in data) {
      data.endsAt = Date.parse(data.endsAt.date);
    }
    if (data.state === "started") {
      for (let question of data.questions) {
        question.answer = localStorage.getItem(question.uid);
      }
    }
    document.body.setAttribute("mz-state", data.state);
    return {
      attempt: data as AttemptModel
    };
  }

  @MutationAction
  async startAttempt(uuid: string) {
    const response: AxiosResponse = await Axios.post(
      process.env.VUE_APP_API_URL + "/api/attempt/start/" + uuid
    );
    const data = response.data;
    data.endsAt = Date.parse(data.endsAt.date);
    for (let question of data.questions) {
      question.answer = localStorage.getItem(question.uid);
    }
    localStorage.removeItem("mojeznalosti-index");
    document.body.setAttribute("mz-state", data.state);
    return {
      attempt: data as AttemptModel
    };
  }

  @MutationAction
  async finishAttempt(attempt: StartedAttemptModel) {
    const answers = attempt.questions
      .map(question => {
        return {
          question: question.uid,
          answer: question.answer || null
        };
      })
      .filter(answer => answer.answer !== null);
    const response: AxiosResponse = await Axios.post(
      process.env.VUE_APP_API_URL + "/api/attempt/finish/" + attempt.uid,
      JSON.stringify(answers)
    );

    const responseAttempt = response.data as AttemptModel;
    document.body.setAttribute("mz-state", responseAttempt.state);
    return {
      attempt: response.data
    };
  }

  @MutationAction
  async retryAttempt(attempt: FinishedAttemptModel) {
    const response: AxiosResponse = await Axios.post(
      process.env.VUE_APP_API_URL + "/api/attempt/retry/" + attempt.uid
    );
    document.body.setAttribute("mz-state", response.data.state);
    return {
      attempt: response.data
    };
  }

  @MutationAction
  async saveAnswers(attempt: AttemptModel) {
    if (attempt.state !== "started") {
      new Error("Cannot save attempt which is not started.");
    }
    const startedAttempt = attempt as StartedAttemptModel;
    const answers = startedAttempt.questions
      .map(question => {
        return {
          question: question.uid,
          answer: question.answer
        };
      })
      .filter(
        question => question.answer !== null && question.answer !== undefined
      );
    await Axios.post(
      process.env.VUE_APP_API_URL + "/api/attempt/save-answers/",
      JSON.stringify(answers)
    );
    return {};
  }

  get imageBySlug() {
    const attempt = this.attempt;
    if (attempt === null) {
      throw new Error("Cannot get image from null Attempt");
    }
    if (!["started", "finished"].includes(attempt.state)) {
      throw new Error(
        "Cannot get image on attempt which is not started or finished"
      );
    }
    const images = (this.attempt as StartedAttemptModel).images;
    return (slug: string) => {
      for (let image of images) {
        if (image.slug === slug) {
          return image;
        }
      }
      throw new Error("Image with slug '" + slug + "' not found in Attempt.");
    };
  }

  get uuid(): string {
    if (this.attemptUuid === null) {
      throw new Error("'mojeznalosti' param not found in url");
    }
    return this.attemptUuid;
  }

  get getAttempt(): AttemptModel {
    if (this.attempt === null) {
      throw new Error("'mojeznalosti' param not found in url");
    }
    return this.attempt;
  }
}

export default getModule(AttemptModule);
